import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import defaultStyles from "./ImageSlider.module.scss";

export interface ICarouselImageSliderProps {
  url: string;
  displayImageAsBackground: boolean;
}

export const CarouselImageSlider = ({
  url,
  displayImageAsBackground,
}: ICarouselImageSliderProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.ImageCarouselImage;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const backgroundStyle = {
    backgroundImage: `url(${url})`,
  };

  return displayImageAsBackground ? (
    <div className={cn("image")} style={backgroundStyle}></div>
  ) : (
    <img className={cn("image")} src={url} alt="" />
  );
};
